export const generateTicket = (id) => {
  return {
    "ActionDate": "2019-07-09T23:59:00",
    "CardID": id,
    "CardSeatsCount": 4,
    "CardStatusID": 3,
    "CardTotalPrice": "1500",
    "CardTypeID": 2,
    "JobID": 2141894,
    "PaymentMethod": "Aman",
    "PromoCode": null,
    "UserEmail": "philopater_boushra@yahoo.com",
    "UserName": "Philopater Boushra",
    "UserTelNo": "01285841225",
    "myTrips": [{
      "CardID": 1415462,
      "ResIDs": [31608217, 31608218, 31608219, 31608220],
      "Seats": [5, 6, 7, 8],
      "SeatsPrices": [180, 180, 180, 180],
      "TripDateTime": "2019-08-01T23:59:00",
      "TripOfficeFrom": "Cairo",
      "TripOfficeFrom_NameA": "القاهرة (عبد المنعم رياض)",
      "TripOfficeFrom_NameE": "Cairo ( Tahrir )",
      "TripOfficeTo": "Sharm",
      "TripOfficeTo_NameA": "شرم الشيخ - الرويسات",
      "TripOfficeTo_NameE": "Sharm El Sheikh (Royssat)",
      "TripSeatsCount": 4,
      "TripServKind": "Economic",
      "TripServKind_NameA": "اقتصادى",
      "TripServKind_NameE": "Economic",
      "TripSubData_Id": 4953264,
      "TripTotalPrice": 720
    }]
  }
}